import { useSettings } from "~/store/settings";
import gcd from "~/utils/sport/gcd";

export const calculatePreBoostedPrice = (price: { priceNumerator: number; priceDenominator: number }) => {
	const settings = useSettings();
	const boostPercentage = settings.config?.appSetting?.boostedOddsPercentage || 0;
	let preBoostedPriceNumerator = price.priceNumerator * 100;
	let preBoostedPriceDenominator = price.priceDenominator * (100 + boostPercentage);
	const gcdVal = gcd(preBoostedPriceNumerator, preBoostedPriceDenominator);
	preBoostedPriceNumerator = preBoostedPriceNumerator / gcdVal;
	preBoostedPriceDenominator = preBoostedPriceDenominator / gcdVal;
	const preBoostedPriceDecimal = 1 + preBoostedPriceNumerator / preBoostedPriceDenominator;

	return {
		preBoostedPriceNumerator,
		preBoostedPriceDenominator,
		preBoostedPriceDecimal,
	};
};
